import { useSearchParams } from "react-router-dom"
import style from "./ChangeIpPage.module.scss";

export function ChangeIpPage() {
    const [queryParams] = useSearchParams()

    return (
        <main className={style.page}>
            <div className={style.container}>
                <div className="max-w-full">
                    <p className={style.label}>Старе IP: </p>
                    <p className={style.value}>{queryParams.get("old_ip") || ""}</p>
                </div>
                <div className="max-w-full">
                    <p className={style.label}>Нове IP: </p>
                    <p className={style.value}>{queryParams.get("new_ip") || ""}</p>
                </div>
            </div>
        </main>
    )
}